import { useQuery } from '@tanstack/react-query';

import { meQuery } from '@/lib/api/queries.ts';
import { useAuth } from '@/services/Auth/index.ts';

export const meQueryKey = meQuery().queryKey;

export const useMe = () => {
  const { isAnonymous } = useAuth();

  return useQuery({
    ...meQuery(),
    enabled: !isAnonymous,
  });
};
